import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useStore } from '../../context/Context';

const MerchantRoute: React.FC<RouteProps> = ({
	component: Component,
	...rest
}) => {
	const {
		store: { user, brand },
	} = useStore();

	if (!Component) {
		return null;
	}

	const isAuthenticated: boolean =
		(user && brand) ||
		user?.user.type === 'admin' ||
		user?.user.type === 'pickup-manager' ||
		user?.user.type === 'accounts'
			? true
			: false;

	return (
		<Route
			{...rest}
			render={(props) =>
				isAuthenticated ? (
					<Component {...props} />
				) : (
					<Redirect
						to={{ pathname: '/login', state: { from: props.location } }}
					/>
				)
			}
		/>
	);
};

export default MerchantRoute;
